import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'bxi-bar-loader',
  imports: [],
  templateUrl: './bar-loader.component.html',
  host: { class: 'bg-bg-quaternary relative h-1 block w-full overflow-hidden' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      .animate-top-loader {
        position: absolute;
        top: 0;
        height: 100%;
        animation: top-loader 1.5s infinite;
        background: linear-gradient(
          to right,
          transparent 0%,
          var(--color-fg-brand-primary-600) 25%,
          var(--color-fg-brand-primary-600) 75%,
          transparent 100%
        );
      }

      @keyframes top-loader {
        0% {
          left: -10%;
          width: 0%;
        }
        30% {
          left: 30%;
          width: 70%;
        }
        60% {
          left: 100%;
          width: 0%;
        }
        100% {
          left: 100%;
        }
      }
    `,
  ],
})
export class BarLoaderComponent {}
